(function() {
    const initAccordions = () => {
        const containers = document.querySelectorAll('[data-accordion-container]');

        containers.forEach((accordion) => {
            const toggle = accordion.querySelector('[data-toggle-accordion]');
            const content = accordion.querySelector('[data-accordion-content]');

            // toggle.addEventListener('click', function() {
            //     toggle.classList.toggle('open');
            //     content.classList.toggle('hide');
            // });
        });
    };

    initAccordions();
    window.initAccordions = initAccordions;

    $(document).on('click', '.add-to-basket-tarrif-mobile', function() {
        let refId = $(this).attr('ref-id');
        if ($(this).hasClass('open')) {
            $('.accordchild' + refId).addClass('hide');
            $('.accord' + refId).removeClass('open');
        } else {
            $('.accord' + refId).addClass('open');
            $('.accordchild' + refId).removeClass('hide');
        }
    });
})();
